import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { DraftStatusBadge } from '@/components/agent-detail/draft-status-badge'
import { PublishStatusBadge } from './publish-status-badge'
import type { BlogDraft } from '@/lib/api/types'

interface DraftStickyHeaderProps {
  draft: BlogDraft
  agentId: string
  isEditing: boolean
  // Reserved for future in-header edit toggles — not consumed today.
  setIsEditing?: (v: boolean) => void
  editActions?: React.ReactNode
  viewActions?: React.ReactNode
}

export function DraftStickyHeader({
  draft,
  agentId,
  isEditing,
  editActions,
  viewActions,
}: DraftStickyHeaderProps) {
  return (
    <div className="bg-card border-b border-border px-4 md:px-8 py-4 sticky top-0 z-10">
      <div className="flex items-center gap-2 mb-2">
        <Link
          to="/agents/$agentId"
          params={{ agentId }}
          search={{ tab: 'drafts' }}
          className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1"
          aria-label="Back to drafts list"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Drafts
        </Link>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <h1 className="text-xl font-medium font-serif truncate">{draft.title}</h1>
          <DraftStatusBadge status={draft.status} scheduledAt={draft.scheduledAt} />
          <PublishStatusBadge publishStatus={draft.publishStatus} publishError={draft.publishError} />
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {isEditing ? editActions : viewActions}
        </div>
      </div>
    </div>
  )
}
